import React from 'react';

// Remembers the URL that failed, not a flag: a refetched record carries a fresh signed URL and should be retried.
export const useImageLoadFailure = (url: string): [failed: boolean, onError: () => void] => {
  const [failedUrl, setFailedUrl] = React.useState<string | null>(null);

  return [failedUrl === url, () => setFailedUrl(url)];
};
